define('util/MissingJourneyContextError',[],function () {
    'use strict';
    function MissingJourneyContextError() {
        this.message = 'The provided conversation has no journey context.';
    }
    MissingJourneyContextError.prototype = Object.create(Error.prototype);
    MissingJourneyContextError.prototype.constructor = MissingJourneyContextError;
    return MissingJourneyContextError;
});
